// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export class Timer {
	private _interval: number;
	private _callback: () => void;
	private _timeout: number = null;
	private _ctx: any = null;

	constructor(ms: number, cb: () => void, ctx?: any) {
		this._interval = ms;
		this._callback = cb;
		this._ctx = ctx || null;
	}

	get running() {
		return this._timeout !== null;
	}

	start() {
		if (this._timeout) return;
		this._timeout = setTimeout(this._handleTimeout, this._interval);
	}

	reset() {
		this.stop();
		this.start();
	}

	stop() {
		if (this.running) {
			clearTimeout(this._timeout);
			this._timeout = null;
		}
	}

	fire() {
		if (this.running) {
			this.stop();
			this._callback.call(this._ctx);
		}
	}

	private _handleTimeout = () => {
		this._timeout = null;
		this._callback.call(this._ctx);
	}
}
